import { ACTION as constants } from './constants';

export function CommandAuthorManualGradingConfigurationGet(componentId) {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_GET,
    componentId,
  };
}

export function ManualGradingConfigurationPut(componentId, maxScore, isEnabled) {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_PUT,
    componentId,
    maxScore,
    isEnabled,
  };
}

export function CommandAuthorManualGradingConfigurationSet(componentId, { maxScore, isEnabled }) {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_SET,
    componentId,
    maxScore,
    isEnabled,
  };
}

export function CommandAuthorManualGradingConfigurationDelete(componentId) {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_DELETE,
    componentId,
  };
}

export function ResponseAuthorManualGradingConfigurationGet() {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_GET_RESPONSE,
  };
}

export function ResponseAuthorManualGradingConfigurationGetError() {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_GET_ERROR,
  };
}

export function ResponseAuthorManualGradingConfigurationMutate() {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_MUTATE_RESPONSE,
  };
}

export function ResponseAuthorManualGradingConfigurationMutateError() {
  return {
    type: constants.AUTHOR_MANUAL_GRADING_CONFIGURATION_MUTATE_ERROR,
  };
}
